import axios from "axios"

let API_NAME = process.env.VUE_APP_API_NAME;

export default {
  async getOrders(accessToken, client_id, range, start_date, end_date, limit, with_quantities, with_interval) {
	  let res = await axios.get(API_NAME + "/orders?client_id=" + client_id + '&range=' + range + '&start_date=' + start_date + '&end_date=' + end_date + '&limit=' + limit + '&with_quantities=' + with_quantities + '&with_interval=' + with_interval, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  
  async saveSampleRequest(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/samples",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async completeSample(accessToken, sample_id, form_data) {
    let res = await axios.post(API_NAME + "/samples/" + sample_id + '/complete',  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async unCompleteSample(accessToken, sample_id, form_data) {
    let res = await axios.post(API_NAME + "/samples/" + sample_id + '/uncomplete',  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async processSample(accessToken, sample_id, form_data) {
    let res = await axios.post(API_NAME + "/samples/" + sample_id + "/process",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async completeSampleItemArea(accessToken, sample_item_id, form_data) {
    let res = await axios.post(API_NAME + "/sample_items/" + sample_item_id + "/complete_area",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
   async unCompleteSampleItemArea(accessToken, sample_item_id, form_data) {
    let res = await axios.post(API_NAME + "/sample_items/" + sample_item_id + "/un_complete_area",
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getNewSamples(accessToken) {
    let res = await axios.get(API_NAME + "/samples?submitted=1&processed=0&completed=0" , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getInProgressSamples(accessToken) {
    let res = await axios.get(API_NAME + "/samples?submitted=1&processed=1&completed=0" , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getSamplesForDigitalPrint(accessToken) {
    let res = await axios.get(API_NAME + "/samples?requiring_digital_print=1&completed=0" , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getSamplesForGerberCutting(accessToken) {
    let res = await axios.get(API_NAME + "/samples?requiring_gerber_cutting=1&completed=0" , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getSamplesForSundries(accessToken) {
    let res = await axios.get(API_NAME + "/samples?requiring_sundries=1&completed=0" , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getSamplesForArtwork(accessToken) {
    let res = await axios.get(API_NAME + "/samples?requiring_artwork=1&completed=0" , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getSamplesForMakeup(accessToken, makeup_location_id) {
    let res = await axios.get(API_NAME + "/samples?requiring_makeup=1&completed=0&makeup_location_id=" + makeup_location_id , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getMySamples(accessToken) {
    let res = await axios.get(API_NAME + "/samples?mysamples=1&completed=0" , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getSamplesMakeupLocations(accessToken) {
    let res = await axios.get(API_NAME + "/locations?samples=1&makeup=1&completed=0" , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  
  async searchSamples(accessToken, sample_id) {
    let res = await axios.get(API_NAME + "/samples/search?sample_id=" + sample_id , {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getSample(accessToken, sample_id) {
    let res = await axios.get(API_NAME + "/samples/" + sample_id, {
        headers: {
        Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveSampleItem(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/sample_items",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveSampleNote(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/sample_notes",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveSampleAttachment(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/sample_attachments",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data"
        }
      });
    return res.data;
  },
 async submitSample(accessToken, sample_id, form_data) {
    let res = await axios.post(API_NAME + "/samples/" + sample_id + "/submit",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async resubmitSample(accessToken, sample_id, form_data) {
    let res = await axios.post(API_NAME + "/samples/" + sample_id + "/resubmit",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },

	

	
  
}